import { render, staticRenderFns } from "./personaldata.vue?vue&type=template&id=58e7704c&scoped=true&"
import script from "./personaldata.vue?vue&type=script&lang=js&"
export * from "./personaldata.vue?vue&type=script&lang=js&"
import style0 from "./personaldata.vue?vue&type=style&index=0&id=58e7704c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e7704c",
  null
  
)

export default component.exports